module.exports = __webpack_public_path__ + "static/media/Tab_Case_Studies_Active.b0640c4e.png";